import moment from 'moment';
import { FiArrowLeftCircle } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { BiSolidEdit, BiSolidTrash, BiBlock } from "react-icons/bi";
import { PiEyeBold } from "react-icons/pi";
import { FaUnlockKeyhole } from "react-icons/fa6";


const submitDATE = (date, errorMessage, setFormDate, setEndDate, setFrom, form_date) => {
    setFormDate(date);
    setEndDate('');
    errorMessage('');

    if (date) {
        const newDate = moment(date).format('YYYY-MM-DD');
        setEndDate(newDate);
        if (!form_date) {
            setFrom(true);
        }
    } else {
        setFrom(false);
    }
};


const tableDATE = (date, setFormDate, setEndDate, setToFormDate, setFrom) => {
    setFormDate(date);
    setEndDate('');
    if (setToFormDate) {
        if (!date) {
            setEndDate('');
            setFrom(true);
        } else {
            setFrom(false);
        }
    } else {
        setFrom(false);
    }

    if (date) {
        const newDate = moment(date).format('YYYY-MM-DD');
        setEndDate(newDate);
        setFrom(false);
    }
};


const onFocusDate = (setHide) => {
    setHide('');
};

const onBlurDate = (setHide, form_date, end_date) => {
    if (form_date) {
        if (!end_date) {
            setHide('This field is required.');
        } else {
            setHide('');
        }
    }
};


const formatMoment = (date) => {
    return date ? moment(date).format('YYYY-MM-DD') : '';
};

const ButtonEdit = ({ onclick }) => {
    return (
        <>
            <button
                className='rounded-[3px] mr-1 mb-1 font-normal border border-transparent border-solid text-[13px] bg-[#3c8dbc] text-white'
                style={{ padding: '5px 6px' }}
                title='Edit User'
                onClick={onclick}>
                <BiSolidEdit size={14} />
            </button>
        </>
    )
}


// Table creation Custom Button
const CustomButton = ({ children, className, style, onClick = () => { } }) => {
    return (
        <button
            className={`rounded-[3px] border border-transparent border-solid text-[13px] ${className}`}
            style={{
                color: "white",
                fontSize: "88%",
                padding: '.3em .6em',
                fontWeight: '600',
                lineHeight: '1.2',
                whiteSpace: 'wrap',
                verticalAlign: 'baseline',
                borderRadius: '.25em',
                textAlign: 'center',
                display: 'inline',
                ...style
            }}
            onClick={onClick}
        >
            {children}
        </button>
    );
};


const ButtonDelete = ({ onclick }) => {
    return (
        <button
            title='Delete'
            className='rounded-[3px] mr-1 mb-1 font-normal border-solid text-[13px] bg-[#dd4b39] text-white border border-[#d73925]'
            style={{ padding: '5px 6px' }}
            onClick={onclick}>
            <BiSolidTrash size={14} />
        </button>
    )
}

const ButtonBlock = ({ onclick, block = true }) => {
    return (
        <button
            title={block ? "Block" : "Unblock"}
            className="rounded-[3px] mr-1 mb-1 font-normal border-solid text-[13px] bg-[#dd4b39] text-white border border-[#d73925]"
            style={{ padding: '5px 6px' }}
            onClick={onclick}
        >
            {block ? (
                <BiBlock size={14} />
            ) : (
                <FaUnlockKeyhole size={14} />
            )}
        </button>
    );
};

// Search And Clear 
const SearchClear = ({ search, clear }) => {
    return (
        <div className="text-right text-white">
            <button
                className="rounded-[3px] mb-1 mr-1 font-normal border border-solid text-sm p-2 bg-[#f97316]"
                onClick={search}
            >
                Search
            </button>
            <button
                className="rounded-[3px] mb-1 mr-1 font-normal border border-solid border-[#ddd] text-sm p-2 bg-[#f4f4f4] text-[#444]"
                onClick={clear}
            >
                Clear
            </button>
        </div>
    )
}

const FormFooterButton = ({ onClick }) => {
    return (
        <div className="flex justify-end space-x-2 mt-4">
            <button
                type="button"
                onClick={onClick}
                className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
            >
                Close
            </button>
            <button
                type="submit"
                className="px-4 py-2 bg-orange-600 text-white rounded hover:bg-orange-700"
            >
                Submit
            </button>
        </div>
    )
}

const InputCss = "w-full px-3 py-2.5 border border-orange-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-orange-400 text-sm text-gray-700 transition-all duration-200";

export { submitDATE, tableDATE, onFocusDate, onBlurDate, formatMoment, ButtonEdit, CustomButton, ButtonDelete, SearchClear, ButtonBlock, InputCss, FormFooterButton };